export const getMtLoginUrl = async () => {
  const authority = process.env.REACT_APP_OPENID_PROVIDER;
  const clientId = process.env.REACT_APP_OPENID_CLIENT_ID;
  const redirectUri = process.env.REACT_APP_OPENID_REDIRECT_URI;
  const responseType = 'code';
  const cript = 'S256';

  const codeVerifier = generatePKCE();
  sessionStorage.setItem('pkce_code_verifier', codeVerifier);
  const codeChallenge = await generateCodeChallenge(codeVerifier);

  if (!authority || !clientId || !redirectUri) {
    console.error('MT-Login não configurado corretamente no .env');
    return null;
  }

  return `${authority}/protocol/openid-connect/auth?` +
    `client_id=${clientId}` +
    `&redirect_uri=${encodeURIComponent(redirectUri)}` +
    `&response_type=${responseType}` +
    `&code_challenge=${codeChallenge}` +
    `&code_challenge_method=${cript}`;
};

function generatePKCE(length = 32) {
  const array = new Uint8Array(length);
  window.crypto.getRandomValues(array);
  const base64 = btoa(String.fromCharCode(...array))
    .replace(/\+/g, "-")
    .replace(/\//g, "_")
    .replace(/=+$/, "");

  return base64; 
}

async function generateCodeChallenge(codeVerifier) {
  const data = new TextEncoder().encode(codeVerifier);
  const digest = await window.crypto.subtle.digest("SHA-256", data);

  return btoa(String.fromCharCode(...new Uint8Array(digest)))
    .replace(/\+/g, "-")
    .replace(/\//g, "_")
    .replace(/=+$/, "");
}


